import React, { useEffect, useState } from 'react';
import { DatePicker } from 'rsuite';

const HomePageTimeDatePicker = ({
  id,
  field,
  row,
  rowNode,
  colDef,
  cellMode,
  hasFocus,
  tabIndex,
  value,
  formattedValue,
  isEditable,
  api,
  state_setter
}) => {
  const [dt, setDt] = useState(null);

  useEffect(() => {
    setDt(new Date(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = async (e) => {
    const date = new Date(e);
    const dd = date.getDate();
    const mm = date.getMonth();
    const yyyy = date.getFullYear();
    const hh = date.getHours();
    const min = date.getMinutes();
    const ss = date.getSeconds();

    const d = `${yyyy}-${mm + 1}-${dd} ${hh}:${min}:${ss}`;
    console.log(api, field);
    api?.updateRows([{ id, [field]: e }]);
    state_setter(prev => ([{
      ...prev[0],
      [field]: date
    }]));
    setDt(date);
    console.log({ d });
  };
  return (
    <div>
      <DatePicker
        format='yyyy-MM-dd HH:mm'
        calendarDefaultDate={dt}
        style={{ width: 200 }}
        value={dt}
        onChange={handleChange}
      />
    </div>
  );
};

export default HomePageTimeDatePicker;